import { render, staticRenderFns } from "./NewPageHeader.vue?vue&type=template&id=617093b6&scoped=true"
import script from "./NewPageHeader.vue?vue&type=script&lang=js"
export * from "./NewPageHeader.vue?vue&type=script&lang=js"
import style0 from "./NewPageHeader.vue?vue&type=style&index=0&id=617093b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617093b6",
  null
  
)

export default component.exports